import { useMemo } from 'react'
import { ADDICTION_TYPES_PAGES } from '../utils'
import AddictionSelection from './AddictionSelection/AddictionSelection'
import FrequencySelection from './FrequencySelection/FrequencySelection'
import GoalSelection from './GoalSelection/GoalSelection'

export default function AddictionTypesSelectionPageStateController({
  formData,
  setFormData,
  finallyGoTo,
  currentPage,
  pushPage,
  webPageType,
}) {
  const ComponentToRender = useMemo(() => {
    switch (currentPage) {
      case ADDICTION_TYPES_PAGES.addictionTypeSelection:
        return AddictionSelection
      case ADDICTION_TYPES_PAGES.addictionFrequencySelection:
        return FrequencySelection
      case ADDICTION_TYPES_PAGES.goalSelection:
        return GoalSelection
      default:
        return AddictionSelection
    }
  }, [currentPage])

  function goToNextPage(selectedAddictionType) {
    switch (currentPage) {
      case ADDICTION_TYPES_PAGES.addictionTypeSelection:
        if (webPageType === 'assessment-selection') {
          finallyGoTo(selectedAddictionType)
          break
        }
        pushPage(ADDICTION_TYPES_PAGES.addictionFrequencySelection)
        break
      case ADDICTION_TYPES_PAGES.addictionFrequencySelection:
        pushPage(ADDICTION_TYPES_PAGES.goalSelection)
        break
      case ADDICTION_TYPES_PAGES.goalSelection:
        finallyGoTo()
        break
      default:
        break
    }
  }

  return (
    <ComponentToRender formData={formData} setFormData={setFormData} goToNextPage={goToNextPage} />
  )
}
